(function (window, document, $, undefined) {
  "use strict";
  // Check that the Sticky Nav wrapper exists and isn't already populated
  if (
    $(".jh-sticky-nav-wrapper").length &&
    !$.trim($(".jh-sticky-nav ul").html()).length
  ) {
    window.stickyNavMenu = {
      /**
       * Initialize script behavior.
       *
       * @since 1.0.0
       */
      init: function () {
        stickyNavMenu.initVars();
        stickyNavMenu.initMenuItems();
        stickyNavMenu.initGetScrollOffset();
        stickyNavMenu.initOffsets();
        stickyNavMenu.toggleFixedPosition();
        stickyNavMenu.setActiveAnchor();
        stickyNavMenu.bind();
        stickyNavMenu.pageSmoothScroll();
      },

      /**
       * Setting and initializing all variables.
       *
       * @since 1.0.0
       */
      initVars: function () {
        stickyNavMenu.$menuWrap = $(".jh-sticky-nav-wrapper");

        stickyNavMenu.$menu = stickyNavMenu.$menuWrap.find(".jh-sticky-nav ul");

        var flRowContent = stickyNavMenu.$menuWrap.parents(
          ".fl-row-content:first"
        );

        if (flRowContent.length > 0) {
          // The sticky nav will be contained by the parent .fl-row-content element if one exists.
          stickyNavMenu.content = flRowContent;
        } else {
          // The sticky nav will be contained by the #content element.
          stickyNavMenu.content = $("#content");
        }

        stickyNavMenu.anchorTargets = $('[data-sticky-nav-include="true"]');
        stickyNavMenu.fixedClass = "fixed";
        stickyNavMenu.activeClass = "active";
      },

      /**
       * Calculate the offset needed when scrolling so the target heading isn't covered up by the admin bar
       *
       * @returns int
       */
      initGetScrollOffset: function () {
        if ($("#wpadminbar").length) {
          return $("#wpadminbar").height();
        } else {
          return 0;
        }
      },

      /**
       * Initialize menu items from all the included headings.
       */
      initMenuItems: function () {
        stickyNavMenu.anchorTargets.each(function (i, e) {
          var $heading = $(e);
          function sl_translate() {} // Smartling Empty Function
          var sl_tr_start = sl_translate; // Smartling start translation
          var label = $heading.data("sticky-nav-label");
          var sl_tr_end = sl_translate; // Smartling end translation
          var id = $heading.attr("id");

          // If the id attributes is not set, we'll set one.
          if (!id) {
            // "Slugify" the label - replace spaces with hyphens and only accept alphanumeric characters.
            id = label
              .toLowerCase()
              .replace(/[^\w ]+/g, "")
              .replace(/ +/g, "-");
            $heading.attr("id", id);
          }

          // Initialize the menu item.
          var $menuItem = $(
            '<li class="sticky-nav-item list-group-item mb-0"><a id="' +
              id +
              "ProductNav" +
              '" href="#' +
              id +
              '">' +
              label +
              "</a></li>"
          );

          // Add the menu item to the menu.
          stickyNavMenu.$menu.append($menuItem);
        });

        // Add the click events to the menu items.
        stickyNavMenu.$menu.find("a").on("click", function (e) {
          e.preventDefault();
          // Tracking onclick events for Analytics
          gtmHelper.inPageInteractionTrack($(this).text(), "Sticky Navigation");
          // Remove active state across all items.
          $(
            "." + stickyNavMenu.activeClass,
            stickyNavMenu.$menuWrap
          ).removeClass(stickyNavMenu.activeClass);
          // Add active to clicked menu item
          $(this).parent("li").addClass("active");
          return false;
        });
      },

      //Function for smooth scrolling from sticky nav
      pageSmoothScroll: function () {
        $('.sticky-nav-item a[href*="#"]')
          // Remove links that don't actually link to anything
          .not('[href="#"]')
          .not('[href="#0"]')
          .click(function (event) {
            var manualOffset;
            //Sets Manual offset for sticky nav
            if ($(".jh-sticky-nav-wrapper").hasClass("fixed")) {
              manualOffset = -85 - stickyNavMenu.initGetScrollOffset();
            } else {
              manualOffset = -129 - stickyNavMenu.initGetScrollOffset();
            }
            // On-page links
            if (
              location.pathname.replace(/^\//, "") ==
                this.pathname.replace(/^\//, "") &&
              location.hostname == this.hostname
            ) {
              // Figure out element to scroll to
              var target = $(this.hash);
              target = target.length
                ? target
                : $("[name=" + this.hash.slice(1) + "]");
              // Does a scroll target exist?
              if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $("html, body").animate(
                  {
                    scrollTop: target.offset().top + manualOffset,
                  },
                  1000,
                  function () {
                    // Callback after animation
                    // Must change focus!
                    var $target = $(target);
                    $target.focus();
                    if ($target.is(":focus")) {
                      // Checking if the target was focused
                      return false;
                    } else {
                      $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                      $target.focus(); // Set focus again
                    }
                  }
                );
              }
            }
          });
      },

      /**
       * Re-establish anchor menu offset position.
       *
       * @since 1.0.0
       */
      initOffsets: function () {
        // Remove the fixed class from the menu wrap.
        stickyNavMenu.$menuWrap.removeClass(stickyNavMenu.fixedClass);

        // Then calculate its height and top offset.
        stickyNavMenu.menuHeight = stickyNavMenu.$menuWrap.height();
        stickyNavMenu.menuOffset = stickyNavMenu.$menuWrap.offset().top;

        // Calculate anchors offsets.
        stickyNavMenu.anchorOffsets = stickyNavMenu.getAnchorOffsets();
      },

      /**
       * Toggle menu fixed styling.
       *
       * @since 1.0.0
       */
      toggleFixedPosition: function (e) {
        // Make the nav sticky when it reaches the top of the viewport (with or without Admin Bar).
        if (
          window.pageYOffset >
          stickyNavMenu.menuOffset - stickyNavMenu.initGetScrollOffset()
        ) {
          stickyNavMenu.$menuWrap.addClass(stickyNavMenu.fixedClass);
        } else {
          // The nav is no longer sticky.
          stickyNavMenu.$menuWrap.removeClass(stickyNavMenu.fixedClass);
        }
      },

      /**
       * Toggle the active state for each anchor menu item.
       *
       * @since 1.0.0
       */
      setActiveAnchor: function () {
        // There are no anchors.
        if (stickyNavMenu.anchorOffsets.length <= 0) {
          return;
        }

        var positions = stickyNavMenu.anchorOffsets.slice().reverse();

        // Remove active state across all items.
        $("." + stickyNavMenu.activeClass, stickyNavMenu.$menuWrap).removeClass(
          stickyNavMenu.activeClass
        );

        // If we're anywhere above the first target, the first target is active.
        if (window.pageYOffset < positions[positions.length - 1]) {
          stickyNavMenu.$menu
            .find(".sticky-nav-item:first")
            .addClass(stickyNavMenu.activeClass);
        } else {
          // Otherwise, set the active state to the bottom-most visible anchor.
          positions.some(function (position, index) {
            // -250 so the active menu item is set slightly before/after the scroll position is reached.
            if (window.pageYOffset > position - 250) {
              stickyNavMenu.$menu
                .find(".sticky-nav-item")
                .eq(-index - 1)
                .addClass(stickyNavMenu.activeClass);
              return true;
            }
          });
        }
      },

      /**
       * Bind all event listeners.
       *
       * @since 1.0.0
       */
      bind: function () {
        $(window).on("scroll resize", function () {
          stickyNavMenu.initOffsets();
          stickyNavMenu.setActiveAnchor();
          stickyNavMenu.toggleFixedPosition();
          stickyNavMenu.setActiveAnchor();
        });
      },

      /**
       * Get vertical start position for each targeted section.
       *
       * @since 1.0.0
       */
      getAnchorOffsets: function () {
        var offsets = [];

        stickyNavMenu.anchorTargets.each(function () {
          var offset = $(this).offset();
          offsets.push(offset.top);
        });

        return offsets;
      },
    };
    stickyNavMenu.init();
  } // End if element exists
})(window, document, jQuery);
